// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var EnrollmentType;
(function (EnrollmentType) {
    EnrollmentType[EnrollmentType["Unknown"] = 0] = "Unknown";
    EnrollmentType[EnrollmentType["Medical"] = 6] = "Medical";
    EnrollmentType[EnrollmentType["Pharmacy"] = 7] = "Pharmacy";
})(EnrollmentType || (EnrollmentType = {}));
//# sourceMappingURL=enrollmentType.js.map